export enum FeedScope {
    Project = 'Project',
    Organisation = 'Organisation'
}

export interface Feed {
  projectId: string;
  toolId: string;
  feedName: string;
  feedScope: FeedScope;
  status: string;
  createdBy: string;
  createdOn: string;
}

export interface FeedRequest {
  projectId: string;
  toolId: string;
  toolProjectId: string;
  feedName: string;
  scope: FeedScope;
}
